"use client";

import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@/components/ui/breadcrumb";
import {
  ShopBreadcrumbsProvider,
  useShopBreadcrumbs,
} from "@/integrations/wordpress/WordPressEcommerceShopBreadcrumbs";

function ShopBreadcrumbsConsumer() {
  const { links, loading, error } = useShopBreadcrumbs();

  if (loading) {
    return (
      <div className="h-5 w-48 bg-muted/40 animate-pulse" aria-hidden="true" />
    );
  }

  if (error || links.length === 0) return null;

  const lastIndex = links.length - 1;

  return (
    <Breadcrumb>
      <BreadcrumbList className="text-muted-foreground font-mono text-xs uppercase tracking-widest">
        {links.map((link, i) => (
          <BreadcrumbItem data-index={i} key={`${link.href}-${i}`}>
            {i === lastIndex ? (
              <BreadcrumbPage className="text-[var(--primary)]">
                {link.title}
              </BreadcrumbPage>
            ) : (
              <>
                <BreadcrumbLink
                  href={link.href}
                  className="text-muted-foreground hover:text-foreground transition-colors"
                >
                  {link.title}
                </BreadcrumbLink>
                <BreadcrumbSeparator className="text-muted-foreground/60" />
              </>
            )}
          </BreadcrumbItem>
        ))}
      </BreadcrumbList>
    </Breadcrumb>
  );
}

export default function Archive() {
  return (
    <section data-section-id="5295"
      id="archive-title"
      className="relative bg-background text-foreground overflow-hidden border-b border-border"
    >
      {}
      <div
        className="absolute inset-0 pointer-events-none opacity-[0.07]"
        aria-hidden="true"
      >
        <div className="absolute inset-y-0 left-1/4 w-px bg-foreground" />
        <div className="absolute inset-y-0 left-2/4 w-px bg-foreground" />
        <div className="absolute inset-y-0 left-3/4 w-px bg-foreground" />
      </div>

      {}
      <div
        className="absolute top-0 right-0 h-24 w-24 pointer-events-none"
        aria-hidden="true"
      >
        <div className="absolute top-0 right-0 h-px w-16 bg-[var(--primary)]" />
        <div className="absolute top-0 right-0 w-px h-16 bg-[var(--primary)]" />
      </div>

      <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-16 sm:py-20 lg:py-28">
        {}
        <div className="mb-8 sm:mb-10">
          <ShopBreadcrumbsProvider>
            <ShopBreadcrumbsConsumer />
          </ShopBreadcrumbsProvider>
        </div>

        {}
        <div className="flex flex-col gap-6">
          <div className="flex items-center gap-4">
            <span className="h-px w-12 bg-[var(--primary)]" aria-hidden="true" />
            <span className="font-mono text-xs uppercase tracking-[0.3em] text-[var(--primary)]">
              Performance
            </span>
          </div>

          <h1 className="font-default font-bold uppercase tracking-tight text-foreground text-5xl sm:text-6xl lg:text-7xl xl:text-8xl leading-[0.95]">
            Elite Peptides
          </h1>

          <p className="font-serif text-lg sm:text-xl text-muted-foreground max-w-2xl leading-relaxed">
            Laboratory-grade compounds engineered for peak performance, rigorous purity standards, and verified research outcomes.
          </p>
        </div>

        {}
        <div className="mt-12 sm:mt-16 flex items-center gap-6">
          <div className="h-px flex-1 bg-border" />
          <span className="font-mono text-xs uppercase tracking-widest text-muted-foreground">
            CATALOG / Research
          </span>
          <div className="h-px w-12 bg-[var(--primary)]" />
        </div>
      </div>
    </section>
  );
}